import { authedApiFetch } from 'utils/Api';

const feedbackService = {
  submitFeedback: async (feedback, product) => {
    return await authedApiFetch({
      endpoint: `/feedback`,
      method: 'POST',
      payload: { body: feedback, product: product },
    });
  }
};

export default feedbackService;